import { useEffect, useState, useRef } from 'react'
import { SDrawerOrModal, SAlert, SMessage } from 'shj-components'
import { Button, Form, Select, Spin, DatePicker, ConfigProvider, Input, message } from 'antd'
import dayjs from 'dayjs'
import { debounce } from 'lodash-es';
import { getEnums } from '@/services/homeService.ts'
import {
  getScpPlan,
  getOrderProjectPlan,
  calculateEndDate,
  submitOrderProjectPlan,
  findTemplateAndSubs,
  checkDesignerSetStartWorkDate
} from '@/services/order.ts';

interface IProps {
  title: string
  orderId: string
  open: boolean
  setOpen: (open: boolean) => void
  reload: () => void
  companyId: string
}
export default function OccupyStartWork(prpos: IProps) {
  const [form] = Form.useForm()
  const expectTime = useRef(0);
  const { open, title, setOpen, orderId, companyId, reload = () => ({}) } = prpos
  const [dictionaryData, setDictionaryData] = useState({})
  const [loading ,setLoading] = useState(false)
  const [loadingScpPlan, setLoadingScpPlan] = useState(false)
  const [dateNumberMap, setDateNumberMap] = useState({})
  const [noDisabledDate, setNoDisabledDate] = useState<Array<any>>([])
  const [nowSelectDate, setNowSelectDate] = useState('');
  const [relaxDateList, setRelaxDateList] = useState<Array<any>>([])
  const [submitDisabled, setSubmitDisabled] = useState(false)
  const [errorList, setErrorList] = useState<Array<any>>([])

  const houseType = Form.useWatch(['scpHouseTypeCode'], form)
  const plannedStartDate = Form.useWatch(['plannedStartDate'], form)
  const constructOnWeekendFlag = Form.useWatch(['constructOnWeekendFlag'], form)

  useEffect(() => {
    console.log('open---->', open)
    if (open) {
      // 获取是否异常信息
      getOptions()
      getDetailInfo()
    }
  }, [open])

  const getDetailInfo = async () => {
    try {
      setLoading(true)
      const checkRes: any = await checkDesignerSetStartWorkDate({
        params: {
          orderId
        }
      })
      if (checkRes?.length) {
        setSubmitDisabled(true)
        setErrorList(checkRes)
      }
      const res: any = await getOrderProjectPlan(orderId)
      if (res?.orderId) {
        form.setFieldsValue({...res, plannedStartDate: dayjs(res.plannedStartDate), plannedEndDate: dayjs(res.plannedEndDate)?.format('YYYY-MM-DD')});
        // 查最小预计工期
        if (res.expectedDays) {
          const dueRes = await findTemplateAndSubs({
            orderId: res?.orderId,
            constructOnWeekendFlag: res.constructOnWeekendFlag,
            scpHouseTypeCode: res.scpHouseTypeCode,
          })
          if (dueRes?.basicDay) {
            expectTime.current = dueRes?.basicDay;
          }
        }
        if (res?.plannedStartDate) {
          // 拉取当前选择开工日期的月数据
          getScpPlanList(dayjs(res?.plannedStartDate)?.startOf('month')?.format('YYYY-MM-DD'))
        }
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const getScpPlanList = async (day?: string) => {
    try {
      setLoadingScpPlan(true);
      const res = await getScpPlan({
        companyId,
        planMonth: day || dayjs()?.startOf('month')?.format('YYYY-MM-DD')
      })
      if (res?.planDetails?.length) {
        setNowSelectDate(day || dayjs()?.startOf('month')?.format('YYYY-MM-DD'));
        const relaxList = res?.planDetails?.map(item => {
          if (item.restSign) {
            return dayjs(item?.planDate)?.format('YYYY-MM-DD');
          }
        });
        setRelaxDateList(relaxList);
        const newMap = {};
        const effectiveList = res?.planDetails?.filter((item) => {
          const number = res?.houseConfigSign === 0
          ? item?.availableStarts : form.getFieldValue('scpHouseTypeCode') === 'newHouse'
          ? item?.newHouseMaxStarts - item?.newHouseOccupiedStarts : form.getFieldValue('scpHouseTypeCode') === 'oldHouse'
          ? item?.oldHouseMaxStarts - item?.oldHouseOccupiedStarts : 0
          newMap[dayjs(item?.planDate)?.format('YYYY-MM-DD')] = number;

          if (number > 0) {
            return true;
          }
          return false;
        })
        // 可选的日期
        const dateList = effectiveList?.map((item) => dayjs(item?.planDate)?.format('YYYY-MM-DD'));
        setNoDisabledDate(dateList);
        // 日期对应的数量
        setDateNumberMap(newMap);
      } else {
        setNowSelectDate(day || dayjs()?.startOf('month')?.format('YYYY-MM-DD'));
        message.error(`${day ? dayjs(day)?.format('YYYY-MM') : dayjs()?.startOf('month')?.format('YYYY-MM')}月未配置销控计划`);
      }
      setLoadingScpPlan(false);
    } catch (err) {
      setLoadingScpPlan(false);
      console.log(err)
    }
  }

  const getOptions = async () => {
    try {
      const res: any = await Promise.allSettled([
        getEnums('pms', 'com.shj.saas.pms.enums.scp.ScpHouseType'),
      ])
      const dataObj = {
        houseTypeEnum: res?.[0]?.value instanceof Array ? res?.[0]?.value : [],
      }
      console.log(res, dataObj)
      setDictionaryData(dataObj)
      // 初始化值

    } catch (err) {
      console.log(err)
    }
  }

  const submitFunc = async (data: any) => {
    try {
      setLoading(true)
      const submitRes = await submitOrderProjectPlan({
        ...data,
        plannedStartDate: dayjs(data?.plannedStartDate)?.valueOf(),
        plannedEndDate:  dayjs(data?.plannedEndDate)?.valueOf(),
        scpHouseTypeCode: form.getFieldValue('scpHouseTypeCode'),
        orderId,
      })
      setLoading(false)
      if (submitRes?.orderId) {
        message.success('提交成功')
        reload()
        onCancel()
      }
    } catch (err) {
      setLoading(false)
    }
  }

  const onsubmit = () => {
    form.validateFields().then(async (res) => {
      SMessage.confirm({
        title: '二次确认',
        content: `确认占用开工资源吗`,
        onOk: () => {
          submitFunc(res)
          return true;
        },
      })
    }).catch((err) => {
      setLoading(false)
    })
  }

  const onCancel = () => {
    setOpen(false)
  }

  const cellRender = (current, info) => {
    if (info.type !== 'date') {
      return info.originNode;
    }
    if (typeof current === 'number' || typeof current === 'string') {
      return <div className="ant-picker-cell-inner">
        <div style={{ lineHeight: '20px'}}>{current}</div>
        <div style={{ lineHeight: '20px'}}>
          {
            (dateNumberMap?.[dayjs(current)?.format('YYYY-MM-DD')] || dateNumberMap?.[dayjs(current)?.format('YYYY-MM-DD')] === 0)
            ? `剩余${dateNumberMap?.[dayjs(current)?.format('YYYY-MM-DD')]}`
            : ''
          }
        </div>
        {
          relaxDateList?.includes(dayjs(current)?.format('YYYY-MM-DD')) ? (
            <div style={{
              position: 'absolute',
              width: '20px',
              height: '20px',
              right: -30,
              top: 0,
              backgroundColor: 'red',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              休
            </div>
          ) : null
        }
      </div>;
    }
    return (
      <div className="ant-picker-cell-inner">
        <div style={{ lineHeight: '20px'}}>{current.date()}</div>
        <div style={{ lineHeight: '20px'}}>
          {
            (dateNumberMap?.[dayjs(current)?.format('YYYY-MM-DD')] || dateNumberMap?.[dayjs(current)?.format('YYYY-MM-DD')] === 0)
            ? `剩余${dateNumberMap?.[dayjs(current)?.format('YYYY-MM-DD')]}`
            : ''
          }
        </div>
        {
          relaxDateList?.includes(dayjs(current)?.format('YYYY-MM-DD')) ? (
            <div style={{
              position: 'absolute',
              width: '20px',
              height: '20px',
              right: -30,
              top: 0,
              backgroundColor: 'red',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              休
            </div>
          ) : null
        }
      </div>
    );
  };

  const handleOpenDatePicker = (value) => {
    const initDate = plannedStartDate ? dayjs(plannedStartDate)?.startOf('month')?.format('YYYY-MM-DD') : '';
    // 打开面板会默认回到表单所在的月，如果上次请求的数据跟表单数据不一致，要重新请求
    if (value && (initDate !== nowSelectDate) ) {
      getScpPlanList(initDate)
    }
  }

  const onChangeDate = (value) => {
    // 重新请求预计工期
    if (value && houseType && constructOnWeekendFlag) {
      handleGetDueDay()
    }
  }

  const handleGetDueDay = async () => {
    try {
      setLoading(true)
      const dueRes = await findTemplateAndSubs({
        orderId,
        constructOnWeekendFlag: form.getFieldValue('constructOnWeekendFlag'),
        scpHouseTypeCode: form.getFieldValue('scpHouseTypeCode'),
      })
      setLoading(false)
      if (dueRes?.basicDay) {
        form.setFieldValue('expectedDays', dueRes?.basicDay)
        expectTime.current = dueRes?.basicDay;
        if (form.getFieldValue('scpHouseTypeCode') && form.getFieldValue('plannedStartDate') && typeof form.getFieldValue('constructOnWeekendFlag') === 'boolean') {
          // 计算完工日期
          handleGetCompleteDate()
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }

  }

  const handleChangeExpectedDays = (e) => {
    if (Number(e?.target?.value) < expectTime.current) {
      message.info('不能小于初始预计工期');
      form.setFieldValue('expectedDays', expectTime.current)
    }
    if (form.getFieldValue('scpHouseTypeCode') && form.getFieldValue('plannedStartDate') && typeof form.getFieldValue('constructOnWeekendFlag') === 'boolean') {
      // 计算完工日期
      handleGetCompleteDate()
    }
  }

  const handleGetCompleteDate = async () => {
    try {
      setLoading(true)
      const res = await calculateEndDate({
        projectId: '0',
        companyId,
        timeLimit: form.getFieldValue('expectedDays'),
        weekDo: form.getFieldValue('constructOnWeekendFlag'),
        plannedStartDate: dayjs(form.getFieldValue('plannedStartDate')).valueOf(),
        calibrateStartDate: dayjs(form.getFieldValue('plannedStartDate')).valueOf(),
      })
      setLoading(false)
      if (typeof res === 'number') {
        form.setFieldValue('plannedEndDate', dayjs(res)?.format('YYYY-MM-DD'))
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const handleChangePanel = (value, mode) => {
    getScpPlanList(dayjs(value)?.startOf('month')?.format('YYYY-MM-DD'))
  }

  const handleChangeHouseType = (value) => {
    form.resetFields(['plannedStartDate', 'constructOnWeekendFlag', 'expectedDays', 'plannedEndDate'])
    expectTime.current = 0;
    // 清空值重新请求当月数据
    getScpPlanList()
  }

  const onChangeWeekendFlag = (value: any) => {
    if (typeof value !== 'boolean') {
      return;
    }
    // 重新请求预计工期
    if (plannedStartDate && houseType) {
      handleGetDueDay()
    }
  }
  
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            {/* disabled={state.errInfo.length} */}
            <Button
              style={{ marginLeft: 15 }}
              loading={loading}
              type="primary"
              onClick={onsubmit}
              disabled={Boolean(errorList?.length)}
            >
              提交
            </Button>
          </div>
        ),
        style: { top:'50px' },
        maskClosable: false
      }}
    >
      <div>
        <Spin spinning={loading}>
          <div>
            {errorList?.length ? <SAlert type="error">
              {
                errorList?.map((item) => (
                  <div style={{ color: 'red' }}>{ item }</div>
                ))
              }
            </SAlert> : null}
            <Form
              form={form}
              layout="vertical"
              style={{
                width: '100%',
                marginTop: '10px'
              }}
            >
              <Form.Item
                name="scpHouseTypeCode"
                label="房屋类型"
                rules={[{ required: true }]}
                style={{ marginBottom: 10 }}
              >
                <Select
                  style={{ width: '100%' }}
                  fieldNames={{label: 'description', value: 'key'}}
                  options={dictionaryData?.houseTypeEnum}
                  onChange={handleChangeHouseType}
                />
              </Form.Item>
              <ConfigProvider
                  theme={{
                    components: {
                      DatePicker: {
                        cellWidth: 108,
                        cellHeight: 40
                      }
                    }
                  }}
                >
                <Form.Item
                  name="plannedStartDate"
                  label="计划开工日期"
                  hidden={!houseType}
                  rules={[{ required: true }]}
                  style={{ marginBottom: 10 }}
                >
                  <DatePicker
                    style={{width: '100%' }}
                    onPanelChange={handleChangePanel}
                    disabledDate={
                      (current) => loadingScpPlan ?
                        (current && (current < dayjs().endOf('day') || current > dayjs().endOf('day'))) :
                        (current && (current < dayjs().add(7, 'day') || !noDisabledDate?.includes(dayjs(current)?.format('YYYY-MM-DD'))))
                    }
                    onChange={onChangeDate}
                    cellRender={cellRender}
                    onOpenChange={handleOpenDatePicker}
                  />
                </Form.Item>
              </ConfigProvider>
              <Form.Item
                name="constructOnWeekendFlag"
                label="节假日是否施工"
                hidden={!houseType}
                rules={[{ required: true }]}
                style={{ marginBottom: 10 }}
              >
                <Select
                  style={{ width: '100%' }}
                  options={[{ label: '是', value: true}, { label: '否', value: false}]}
                  onChange={onChangeWeekendFlag}
                />
              </Form.Item>
              <Form.Item
                name="expectedDays"
                label="预计工期"
                hidden={!houseType}
                rules={[{ required: true }]}
                style={{ marginBottom: 10 }}
              >
                <Input style={{ width: '100%' }} type='number' onChange={debounce(handleChangeExpectedDays, 1000)} />
              </Form.Item>
              <Form.Item
                name="plannedEndDate"
                label="预计完工日期"
                hidden={!houseType}
           
                style={{ marginBottom: 10 }}
              >
                <Input disabled style={{ width: '100%' }}/>
              </Form.Item>
            </Form>
          </div>
        </Spin>
      </div>
    </SDrawerOrModal>
  )
}
